import { render, staticRenderFns } from "./NeedAssistant.vue?vue&type=template&id=80f4df42&scoped=true"
import script from "./NeedAssistant.vue?vue&type=script&lang=js"
export * from "./NeedAssistant.vue?vue&type=script&lang=js"
import style0 from "./NeedAssistant.vue?vue&type=style&index=0&id=80f4df42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f4df42",
  null
  
)

export default component.exports